module.exports = __webpack_public_path__ + "static/img/full2.9446b1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/full2.png
// module id = Avno
// module chunks = 24